export default __webpack_public_path__ + "static/media/icon-facebook.d0a07c1f.svg";